import { Children, type ReactNode, memo } from 'react'

import './Row.css'

/**
 * Row component for layout management
 * Arranges child components in a horizontal row with specific width allocations:
 * - Control panel: 14%
 * - Fretboard: 83%  
 * - Arrangement controls: 3%
 */

interface RowProps {
  children: ReactNode;
  className?: string;
}

export function Row({ children, className = '' }: RowProps) {
  return (
    <div className={`row-container ${className}`}>
      {Children.map(children, (child, index) => {
        let width: string;
        // Control panel gets 14%
        if (index === 0) width = '14.0%';
        // Fretboard gets 83%
        else if (index === 1) width = '83%';
        // Arrangement controls get 3%
        else if (index === 2) width = '3%';
        else width = 'auto'; // fallback for any additional children
        
        return (
          <div key={index} style={{ width }}>
            {child}
          </div>
        );
      })}
    </div>
  );
}

// Memoize Row component for performance optimization
// Re-renders only when children or className change
export default memo(Row);
